import React, { useState } from 'react';

import MatchSummaryBox from '../MatchSummaryBox';
import { Pagination } from 'antd';

const PAGE_SIZE = 10;

export default function Matches({
  matches,
  users,
  courts,
}: {
  matches: Matches.Match[];
  users: Users.User[];
  courts: Courts.Court[];
}) {
  const [displayMatches, setDisplayMatches] = useState(matches.slice(0, 10));

  const paginationChange = (page: number) => {
    const startIndex = (page - 1) * PAGE_SIZE;
    const endIndex = page * PAGE_SIZE;
    setDisplayMatches(matches.slice(startIndex, endIndex));
    scrollToTop();
  };

  const scrollToTop = () => {
    const topOfNews = document.getElementById('matches')?.getBoundingClientRect().top || 0;
    const windowPositionOfY = window.scrollY;
    window.scrollTo(0, topOfNews + windowPositionOfY);
  };

  return (
    <>
      <div id="matches">
        {displayMatches?.map((item, index) => (
          <MatchSummaryBox
            key={item.id}
            match={item}
            offering={users.find(user => user.id === item.kul_t_id)}
            opponent={users.find(user => user.id === item.kul_r_id)}
            courtName={courts.find(court => court.id === item.kort_id)?.kort_ad || ''}
            className={`${index % 2 !== 0 ? 'mb-xl' : ''}`}
          />
        ))}
      </div>
      <div className="matches-pagination">
        <Pagination
          onChange={paginationChange}
          defaultCurrent={1}
          defaultPageSize={PAGE_SIZE}
          total={matches.length}
          hideOnSinglePage
        />
      </div>
    </>
  );
}
